import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { InboxNotificationWire } from '@/server/routers/notification';
import { trpc } from '@/utils/trpc';
import NotificationBell from './NotificationBell';
const NotificationBellContainer = () => {
  const $ = _c(23);
  const router = useRouter();
  const utils = trpc.useUtils();
  const [open, setOpen] = useState(false);
  const {
    data: unreadCount
  } = trpc.notification.unreadCount.useQuery();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== open) {
    t1 = {
      enabled: open
    };
    $[1] = open;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: notifications,
    isLoading
  } = trpc.notification.list.useQuery(t0, t1);
  let t2;
  if ($[3] !== utils) {
    t2 = () => Promise.all([utils.notification.list.invalidate(), utils.notification.unreadCount.invalidate()]);
    $[3] = utils;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const invalidate = t2;
  let t3;
  if ($[5] !== invalidate) {
    t3 = {
      onSettled: invalidate
    };
    $[5] = invalidate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    mutate: markRead
  } = trpc.notification.markRead.useMutation(t3);
  let t4;
  if ($[7] !== invalidate) {
    t4 = {
      onSettled: invalidate
    };
    $[7] = invalidate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    mutate: markAllRead
  } = trpc.notification.markAllRead.useMutation(t4);
  let t5;
  if ($[9] !== markRead || $[10] !== router) {
    t5 = notification => {
      if (!notification.readAt) {
        markRead({
          notificationIds: [notification.id]
        });
      }
      setOpen(false);
      router.push(notification.url);
    };
    $[9] = markRead;
    $[10] = router;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const openNotification = t5;
  let t6;
  if ($[12] !== notifications) {
    t6 = notifications ?? [];
    $[12] = notifications;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = unreadCount ?? 0;
  let t8;
  if ($[14] !== markAllRead) {
    t8 = () => markAllRead();
    $[14] = markAllRead;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isLoading || $[17] !== open || $[18] !== openNotification || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <NotificationBell isLoading={isLoading} notifications={t6} open={open} unreadCount={t7} onMarkAllRead={t8} onOpenChange={setOpen} onOpenNotification={openNotification} />;
    $[16] = isLoading;
    $[17] = open;
    $[18] = openNotification;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default NotificationBellContainer;